import { debounce } from "lodash";
import * as React from "react";

import { Button, Grid, Input, InputOnChangeData, Table } from "semantic-ui-react";

import { isSystemAdminUser } from "@teamprevent/common/auth/roles";
import { getYesNoOptionEnabledDisplayValue } from "@teamprevent/common/model";

import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { workGroupsSelector } from "../selectors";

import { ApplicationState } from "../../../applicationState";

import { loadWorkGroups } from "../actions";

import { Link, replace } from "redux-little-router";

export const All: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const path = useSelector((state: ApplicationState) => state.router.pathname);
    const customerId = useSelector((state: ApplicationState) => state.router.params.customerId);
    const workGroups = useSelector(workGroupsSelector);
    const currentUser = useSelector((state: ApplicationState) => state.currentUser);
    const [searchValue, setSearchValue] = React.useState(useSelector((state: ApplicationState) => state.router.query.name || ""));

    const debouncedUpdateFilter = debounce((name: string) => dispatch(replace({ pathname: "", query: { name } })), 200);

    const onFilterValueChange = React.useCallback((_: any, { value }: InputOnChangeData) => {
        setSearchValue(value);
        debouncedUpdateFilter(value);
    }, [debouncedUpdateFilter]);

    React.useEffect(() => {
        dispatch(loadWorkGroups({ customerId }));
    }, [customerId, dispatch]);

    return (
        <Grid container className="nomargintop">
            <Grid.Row>
                <Grid.Column width={14}>
                    <h1>Work Groups</h1>
                </Grid.Column>
                <Grid.Column width={2} textAlign="right">
                    {isSystemAdminUser(currentUser) && <Button icon="add" content="Create" as={Link} href={`${path}/create`} />}
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={16}>
                    <Table>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Name</Table.HeaderCell>
                                <Table.HeaderCell>Fast Track</Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell>
                                    <Input
                                        value={searchValue}
                                        onChange={onFilterValueChange}
                                        icon="search"
                                        placeholder="Search..."
                                        size="mini"
                                    />
                                </Table.HeaderCell>
                                <Table.HeaderCell />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {workGroups && workGroups
                                .filter(workGroup => workGroup.name.toUpperCase().startsWith(searchValue.toUpperCase()))
                                .map(workGroup => (
                                    <Table.Row key={workGroup.id}>
                                        <Table.Cell>
                                            <Link href={`${path}/${workGroup.id}`}>
                                                {workGroup.name}
                                            </Link>
                                        </Table.Cell>
                                        <Table.Cell>
                                            {getYesNoOptionEnabledDisplayValue(workGroup.isFastTrackPitPupSpecific || false)}
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                        </Table.Body>
                    </Table>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};
